export default __webpack_public_path__ + "static/media/weight_card_2@3x.3434e8bd.png";